module.exports = __webpack_public_path__ + "static/img/ic_weixin_white.3bd5be59.png";